import styled from 'styled-components';

export const FinancialsHeader = styled.header`
  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;
  border-bottom: 0.5rem solid ${({ theme }) => theme.colors.gray8};

  width: 100%;

  & > .title {
    font-size: 1.625rem;
    font-weight: 700;
    margin-bottom: 1.25rem;
  }
`;

export const CustomersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 60%;
  width: 100%;
  margin-top: 0.875rem;
  flex-direction: row;

  & > div.input-periodo {
    margin-right: 1.5rem;
    min-width: 19rem;
  }

  & > div.input-status {
    min-width: 12rem;
    margin-right: 1.5rem;
  }

  & > div.input-search {
    min-width: 23rem;
    margin-right: 1.5rem;
  }

  & > button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1.25rem;
    min-width: 19rem;
  }
`;
